/* Cho-Yeh Trading Post: menus, search, slide-out cart, product options, collection tools.
   Plain JavaScript, no dependencies. Everything degrades to normal links and form posts without it. */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var parts = (n / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(re), v;
    switch (m && m[1]) {
      case 'amount_no_decimals': v = num(cents, 0); break;
      case 'amount_with_comma_separator': v = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = num(cents, 2, "'", '.'); break;
      default: v = num(cents, 2);
    }
    var tmp = document.createElement('div');
    tmp.innerHTML = fmt.replace(re, v);
    return tmp.textContent;
  }

  /* ---------- slide-in layers (menu, cart, filters) ---------- */
  var openLayer = null, returnFocus = null;
  function focusables(el) {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetWidth || n.offsetHeight || n.getClientRects().length; });
  }
  function openLayerEl(layer, opener) {
    if (!layer) return;
    if (openLayer && openLayer !== layer) closeLayerEl(openLayer, true);
    returnFocus = opener || document.activeElement;
    if (layer.hasAttribute('data-cy-layer')) {
      layer.removeAttribute('inert');
      layer.setAttribute('aria-hidden', 'false');
    }
    layer.classList.add('is-open');
    document.documentElement.classList.add('cy-locked');
    openLayer = layer;
    $$('[aria-controls="' + layer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = $('[data-cy-panel]', layer) || layer;
    window.setTimeout(function () {
      var f = focusables(panel);
      (f[0] || panel).focus({ preventScroll: true });
    }, 50);
  }
  function closeLayerEl(layer, silent) {
    layer = layer || openLayer;
    if (!layer) return;
    layer.classList.remove('is-open');
    if (layer.hasAttribute('data-cy-layer')) {
      layer.setAttribute('inert', '');
      layer.setAttribute('aria-hidden', 'true');
    }
    document.documentElement.classList.remove('cy-locked');
    $$('[aria-controls="' + layer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (openLayer === layer) openLayer = null;
    if (!silent && returnFocus && document.contains(returnFocus)) returnFocus.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (openLayer) { closeLayerEl(); return; }
      var sp = document.getElementById('CySearch');
      if (sp && !sp.hidden) { toggleSearch(false); return; }
      $$('.cy-nav__dd[open]').forEach(function (d) { d.removeAttribute('open'); });
    }
    if (e.key === 'Tab' && openLayer) {
      var panel = $('[data-cy-panel]', openLayer) || openLayer;
      var f = focusables(panel);
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- header: menu, search, dropdowns ---------- */
  function toggleSearch(force) {
    var panel = document.getElementById('CySearch');
    if (!panel) return;
    var show = typeof force === 'boolean' ? force : panel.hidden;
    panel.hidden = !show;
    $$('[data-cy-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', show ? 'true' : 'false'); });
    if (show) { var input = $('input[type="search"]', panel); if (input) input.focus(); }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-cy-menu-open]'))) { e.preventDefault(); openLayerEl(document.getElementById('CyMenuDrawer'), el); return; }
    if ((el = t.closest('[data-cy-search-toggle]'))) { e.preventDefault(); if (openLayer) closeLayerEl(null, true); toggleSearch(); return; }
    if ((el = t.closest('[data-cy-filter-open]'))) { e.preventDefault(); openLayerEl(document.getElementById('CyFacetsLayer'), el); return; }
    if ((el = t.closest('[data-cy-close]'))) {
      var layer = el.closest('.cy-layer, .cy-facets-layer');
      if (layer) { e.preventDefault(); closeLayerEl(layer); return; }
    }
    if ((el = t.closest('[data-cy-cart-open]'))) {
      var drawer = document.getElementById('CyCartDrawer');
      if (drawer && !document.body.classList.contains('cy-on-cart-page')) { e.preventDefault(); openLayerEl(drawer, el); }
      return;
    }
    if ((el = t.closest('[data-cy-open-details]'))) {
      var target = document.querySelector(el.getAttribute('href'));
      if (target && target.tagName === 'DETAILS') {
        e.preventDefault();
        target.open = true;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var s = $('summary', target); if (s) s.focus({ preventScroll: true });
      }
      return;
    }
    /* close an open nav dropdown when clicking anywhere else */
    $$('.cy-nav__dd[open]').forEach(function (d) { if (!d.contains(t)) d.removeAttribute('open'); });
  });

  /* ---------- cart ---------- */
  var Cart = {
    drawer: function () { return document.getElementById('CyCartDrawer'); },
    page: function () { return document.getElementById('CyCartPage'); },
    sections: function () {
      var list = ['cy-cart-drawer'];
      var page = Cart.page();
      if (page && page.dataset.sectionId) list.push(page.dataset.sectionId);
      return list;
    },
    setCount: function (n) {
      $$('[data-cy-cart-count]').forEach(function (b) {
        b.textContent = n;
        b.hidden = !(n > 0);
      });
      $$('[data-cy-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items')); });
    },
    render: function (sections) {
      if (!sections) return;
      var focusSel = Cart.focusKey();
      var html = sections['cy-cart-drawer'];
      if (html) {
        var fresh = parse(html).getElementById('CyCartDrawerInner');
        var cur = document.getElementById('CyCartDrawerInner');
        if (fresh && cur) {
          cur.replaceWith(fresh);
          Cart.setCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
        }
      }
      var page = Cart.page();
      if (page && sections[page.dataset.sectionId]) {
        var freshPage = parse(sections[page.dataset.sectionId]).getElementById('CyCartPage');
        if (freshPage) page.replaceWith(freshPage);
      }
      if (focusSel) {
        var again = document.querySelector(focusSel);
        if (again) again.focus({ preventScroll: true });
        else {
          var scope = openLayer || document.getElementById('CyCartPage');
          var fallback = scope && $('[data-cy-focus-after-remove], .cy-drawer__head button, h1', scope);
          if (fallback) fallback.focus({ preventScroll: true });
        }
      }
    },
    focusKey: function () {
      var a = document.activeElement;
      if (!a || !a.dataset || !a.dataset.key) return null;
      var scope = a.closest('#CyCartDrawer') ? '#CyCartDrawer ' : '#CyCartPage ';
      var key = (window.CSS && CSS.escape) ? CSS.escape(a.dataset.key) : a.dataset.key;
      if (a.hasAttribute('data-cy-line-step')) return scope + '[data-cy-line-step="' + a.getAttribute('data-cy-line-step') + '"][data-key="' + key + '"]';
      if (a.hasAttribute('data-cy-line-qty')) return scope + '[data-cy-line-qty][data-key="' + key + '"]';
      if (a.hasAttribute('data-cy-line-remove')) return scope + '[data-cy-line-remove][data-key="' + key + '"]';
      return null;
    },
    busy: function (on) {
      var d = Cart.drawer(), p = Cart.page();
      if (d) $('.cy-drawer', d).classList.toggle('is-busy', on);
      if (p) p.classList.toggle('is-busy', on);
    },
    error: function (msg) {
      $$('[data-cy-cart-error]').forEach(function (el) {
        el.textContent = msg || '';
        el.hidden = !msg;
      });
    },
    change: function (key, qty) {
      Cart.busy(true);
      Cart.error('');
      return fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: Cart.sections(), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
        .then(function (state) {
          Cart.render(state.sections);
          document.dispatchEvent(new CustomEvent('cy:cart-updated', { detail: state }));
        })
        .catch(function (err) {
          Cart.error((err && (err.description || err.message)) || 'Something went wrong. Please try again.');
          Cart.refresh();
        })
        .then(function () { Cart.busy(false); });
    },
    refresh: function () {
      return fetch(ROOT + '?sections=' + Cart.sections().join(','), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (sections) { Cart.render(sections); })
        .catch(function () {});
    }
  };
  window.CyCart = Cart;

  var pendingQty = {};
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-cy-line-step]');
    if (step) {
      var input = $('[data-cy-line-qty]', step.closest('.cy-qty'));
      if (!input) return;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-cy-line-step'), 10));
      input.value = next;
      var key = step.getAttribute('data-key');
      clearTimeout(pendingQty[key]);
      pendingQty[key] = setTimeout(function () { Cart.change(key, next); }, 300);
      return;
    }
    var rm = e.target.closest('[data-cy-line-remove]');
    if (rm) { e.preventDefault(); Cart.change(rm.getAttribute('data-key'), 0); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cy-line-qty]');
    if (!input) return;
    var q = Math.max(0, parseInt(input.value, 10) || 0);
    Cart.change(input.getAttribute('data-key'), q);
  });

  /* add to cart from product forms */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cy-add]');
    if (!form || !Cart.drawer() || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    var err = $('[data-cy-form-error]', form);
    if (err) { err.hidden = true; err.textContent = ''; }
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-disabled', 'true'); }
    var fd = new FormData(form);
    fd.append('sections', Cart.sections().join(','));
    fd.append('sections_url', window.location.pathname);
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (err) { err.textContent = res.description || res.message || 'That couldn’t be added to your cart.'; err.hidden = false; }
          return;
        }
        Cart.render(res.sections);
        openLayerEl(Cart.drawer(), btn);
        document.dispatchEvent(new CustomEvent('cy:cart-added', { detail: res }));
      })
      .catch(function () {
        if (err) { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; }
      })
      .then(function () { if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-disabled'); } });
  });

  /* keep the count honest when someone comes back with the browser's back button */
  window.addEventListener('pageshow', function (e) { if (e.persisted && Cart.drawer()) Cart.refresh(); });

  /* ---------- product page ---------- */
  function initProduct(el) {
    if (el.dataset.cyReady) return;
    el.dataset.cyReady = '1';
    var json = $('[data-cy-product-json]', el);
    var data = json ? JSON.parse(json.textContent) : null;
    var form = $('form[data-cy-add]', el);
    var idInput = form && $('input[name="id"]', form);
    var priceEl = $('[data-cy-price]', el);
    var submit = form && $('[data-cy-submit]', form);
    var submitText = submit && $('[data-cy-submit-text]', submit);
    var main = $('[data-cy-main]', el);

    function showMedia(id) {
      var thumb = $('[data-cy-thumb][data-media-id="' + id + '"]', el);
      if (!thumb || !main) return;
      var img = $('img', main);
      if (img) {
        img.srcset = thumb.getAttribute('data-srcset') || '';
        img.src = thumb.getAttribute('data-src');
        img.alt = thumb.getAttribute('data-alt') || '';
      }
      $$('[data-cy-thumb]', el).forEach(function (t) {
        var on = t === thumb;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
    $$('[data-cy-thumb]', el).forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-media-id')); });
    });

    $$('[data-cy-step]', el).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = $('input', b.closest('.cy-qty'));
        var min = parseInt(input.min, 10) || 1;
        input.value = Math.max(min, Math.min(999, (parseInt(input.value, 10) || min) + parseInt(b.getAttribute('data-cy-step'), 10)));
      });
    });

    if (!data || !idInput) return;
    var selected = data.selected.slice();

    function availableWith(index, value) {
      return data.variants.some(function (v) {
        if (!v.available || v.options[index] !== value) return false;
        for (var j = 0; j < selected.length; j++) if (j !== index && v.options[j] !== selected[j]) return false;
        return true;
      });
    }
    function exact() {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
    }
    function best(index, value) {
      var score = function (v) {
        var s = v.available ? 100 : 0;
        v.options.forEach(function (o, i) { if (i !== index && o === selected[i]) s += 10 - i; });
        return s;
      };
      return data.variants.filter(function (v) { return v.options[index] === value; })
        .sort(function (a, b) { return score(b) - score(a); })[0];
    }
    function paint(v, initial) {
      $$('[data-cy-opt]', el).forEach(function (b) {
        var i = parseInt(b.getAttribute('data-index'), 10), val = b.getAttribute('data-value');
        var on = selected[i] === val;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-out', !availableWith(i, val));
      });
      $$('[data-cy-opt-label]', el).forEach(function (s) { s.textContent = selected[parseInt(s.getAttribute('data-index'), 10)] || ''; });
      if (!v) {
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      if (priceEl) {
        priceEl.textContent = formatMoney(v.price, data.moneyFormat);
        if (v.compare > v.price) {
          var s = document.createElement('s');
          s.textContent = formatMoney(v.compare, data.moneyFormat);
          priceEl.appendChild(document.createTextNode(' '));
          priceEl.appendChild(s);
        }
      }
      if (submit) submit.disabled = !v.available;
      if (submitText) submitText.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (initial) return;
      if (v.media) showMedia(v.media);
      if (data.updateUrl !== false && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      el.dispatchEvent(new CustomEvent('cy:variant-change', { bubbles: true, detail: { variant: v } }));
    }

    $$('[data-cy-opt]', el).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = parseInt(b.getAttribute('data-index'), 10), val = b.getAttribute('data-value');
        selected[i] = val;
        var v = exact();
        if (!v) { v = best(i, val); if (v) selected = v.options.slice(); }
        paint(v);
      });
    });
    paint(exact(), true);
  }

  /* ---------- collection page ---------- */
  document.addEventListener('change', function (e) {
    var sort = e.target.closest('select[data-cy-sort]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  document.addEventListener('click', function (e) {
    var more = e.target.closest('a[data-cy-load-more]');
    if (!more) return;
    var grid = document.querySelector('[data-cy-grid]');
    var holder = more.closest('[data-cy-more]');
    var sectionId = holder && holder.getAttribute('data-section-id');
    if (!grid || !sectionId) return;
    e.preventDefault();
    more.classList.add('is-busy');
    var url = new URL(more.href, window.location.href);
    url.searchParams.set('section_id', sectionId);
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parse(html);
        var cards = doc.querySelector('[data-cy-grid]');
        if (cards) Array.prototype.slice.call(cards.children).forEach(function (c) { grid.appendChild(c); });
        var next = doc.querySelector('[data-cy-more]');
        if (next) holder.replaceWith(next); else holder.remove();
      })
      .catch(function () { window.location.href = more.href; });
  });

  /* ---------- product recommendations ---------- */
  function initRecs(el) {
    if (el.dataset.cyReady) return;
    el.dataset.cyReady = '1';
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = parse(html).querySelector('[data-cy-recs]');
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- boot (and re-boot inside the theme editor) ---------- */
  function boot(scope) {
    $$('[data-cy-product]', scope).forEach(initProduct);
    $$('[data-cy-recs][data-url]', scope).forEach(initRecs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
